import { Pipe, PipeTransform } from '@angular/core';
import { IResourceListItem } from '@outlook-addin/cue-http';
import { localized } from '@cue/translate';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'resourceAlphabetically',
  standalone: true,
})
export class ResourceAlphabeticallyPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(dataList: IResourceListItem[]): IResourceListItem[] {
    const result = dataList.sort((a, b) =>
      this.getResourceName(a).localeCompare(this.getResourceName(b), this.translocoService.getActiveLang())
    );
    return result;
  }

  private getResourceName(item: IResourceListItem): string {
    return (
      localized(item.resourceDisplayNameForApp, this.translocoService) ||
      localized(item.resourceDisplayName, this.translocoService) ||
      item.resourceDisplayNameForApp?.['ɵvalue'] ||
      item.resourceDisplayName?.['ɵvalue'] ||
      item.resourceUserName ||
      ''
    );
  }
}
